import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageToggle = () => {
    const { language, toggleLanguage } = useLanguage();

    return (
        <button
            className="theme-toggle"
            onClick={toggleLanguage}
            aria-label="Toggle Language"
            title={language === 'en' ? 'Switch to Norwegian' : 'Bytt til engelsk'}
            style={{
                fontSize: '0.9rem',
                fontWeight: '600',
                width: '30px',
                height: '30px',
                border: '1px solid var(--border-color)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            {language.toUpperCase()}
        </button>
    );
};

export default LanguageToggle;
